<template>
  <v-container
    fluid
  >
    <v-row
      v-if="this.$slots.svgIcon"
      justify="center"
      align="center"
      class="ma-0"
    >
      <slot name="svgIcon"/>
    </v-row>
    <v-row
      v-if="this.$slots.icon"
      justify="center"
      align="center"
      class="ma-0"
    >
      <slot name="icon"/>
    </v-row>
    <v-row
      v-if="this.$slots.title"
      justify="center"
      align="center"
      class="ma-0"
    >
      <div class="title">
        <slot name="title"/>
      </div>
    </v-row>
    <v-row
      v-if="this.$slots.description"
      justify="center"
      align="center"
      class="ma-0"
    >
      <div class="description">
        <slot name="description"/>
      </div>
    </v-row>
    <slot name="overlay"/>
  </v-container>
</template>

<script>
  export default {
    name: "EmptyState",
    props: {
      color: {
        type: String,
        default: ""
      }
    }
  }
</script>

<style scoped lang="scss">
  .v-icon {
    font-size: 160px !important;
  }

  .title {
    font-size: 26px;
    font-weight: 500;
    line-height: 40px;
  }

  .description {
    margin: 1em 0;
    font-size: 16px;
    line-height: 24px;
  }
</style>
